import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DynamicFormBuilderService {
  private showFieldEmptyError = new Subject<void>();
  showFieldEmptyError$ = this.showFieldEmptyError.asObservable();

  /**
   * Broadcast to all fields to show error message when required and empty
   */
  EnableShowFieldEmptyError() {
    this.showFieldEmptyError.next();
  }
}
